import * as t from "./web_light_values";
const LightTheme = {
  colors: t.colors,
  fonts: t.fonts,
  space: t.space,
  sizes: t.sizes,
  fontWeights: t.fontWeights,
  fontSizes: t.fontSizes,
  lineHeights: t.lineHeights,
  letterSpacings: t.letterSpacings,
  radii: t.radii,
  shadows: t.shadows,
  zIndices: t.zIndices,
  easings: t.easings,
  durations: t.durations,
  breakpoints: t.breakpoints,
  responsiveThresholds: t.responsiveThresholds,
  borderWidths: t.borderWidths,
  typography: t.typography
};
export {
  LightTheme
};
